import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'booking-contact-section',
    templateUrl: './contact-section.component.html',
    styleUrls: ['./contact-section.component.scss'],
    standalone: false
})
export class ContactSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
